export const TMDB_API_BASE_URL = "https://api.themoviedb.org/3"
export const LANGUAGE = 'fr-FR';

export const COLLECTIONS_VISIBILITY = {
    towatch: {
        param: 'hideTW',
        label: 'À voir'
    },
    watched: {
        param: 'hideW',
        label: 'Vus'
    },
    rewatch: {
        param: 'hideRW',
        label: 'À Revoir'
    },
    ignored: {
        param: 'hideIGN',
        label: 'Ignorés'
    }
}